/**
 * 系统列表 → 普通 Select options（与 `/issue/systemList` 等接口字段一致）。
 * 顶部导航按业务领域分组请使用 `systemGroupedSelectOptions`。
 */

export type SystemListItem = {
  systemId: string;
  systemName?: string;
  businessName?: string;
  [key: string]: any;
};

function isAllSystemItem(item: SystemListItem): boolean {
  return String(item.systemId ?? '').toLowerCase() === 'all';
}

export type BuildSystemSelectOptionsParams = {
  /** 不包含「全部」项（systemId === 'all'） */
  excludeAll?: boolean;
};

export function buildSystemSelectOptions(
  systemList: SystemListItem[] | undefined,
  params?: BuildSystemSelectOptionsParams,
): { label: string; value: string }[] {
  if (!systemList?.length) return [];
  let list = systemList;
  if (params?.excludeAll) {
    list = list.filter((x) => !isAllSystemItem(x));
  }
  return [...list]
    .sort((a, b) => (a.systemName || '').localeCompare(b.systemName || '', 'zh-CN'))
    .map((item) => ({
      label: String(item.systemName ?? ''),
      value: String(item.systemId ?? ''),
    }));
}
